import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestPostList = ({ pageNumber }) => {
  let getUrl = '/user/post/list';
  if (pageNumber) {
    getUrl += `/${pageNumber}`;
  }
  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestSavePost = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/post/save',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestPostList,
  requestSavePost,
};
